function sofiaFetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function sofiaGetSelectedVariant(sofiaMainProduct) {
  // FIXME: Scope this to .sofia-variant-picker
  const selectedVariant = sofiaMainProduct.querySelector(
    "[data-sofia-selected-variant]"
  )?.innerHTML;
  return !!selectedVariant ? JSON.parse(selectedVariant) : null;
}

function sofiaHandleVariantSelect(selectedOptionValues) {
  const sofiaMainProduct = document.querySelector(".sofia-main-product");
  const sofiaMainProductForm = sofiaMainProduct?.querySelector(".sofia-main-product-form");
  if (!sofiaMainProductForm) return;
  
  const productUrl = sofiaMainProduct.dataset.sofiaUrl;
  if (!productUrl) return;

  sofiaRenderProductInfo({
    requestUrl: sofiaBuildRequestUrlWithParams(productUrl, selectedOptionValues),
    callback: sofiaHandleUpdateProductInfo(productUrl),
  });
}

function sofiaBuildRequestUrlWithParams(url, optionValues) {
  const params = [];

  if (optionValues.length) {
    params.push(`option_values=${optionValues.join(",")}`);
  }

  return `${url}?${params.join("&")}`;
}

function sofiaRenderProductInfo({ requestUrl, callback }) {
  fetch(requestUrl)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(
        responseText,
        "text/html"
      );
      callback(html);
    })
    .catch(console.error);
}

function sofiaUpdateVariantInputs(variantId) {
  const sofiaMainProduct = document.querySelector(".sofia-main-product");
  const sofiaMainProductForm = sofiaMainProduct?.querySelector(".sofia-main-product-form");
  if (!sofiaMainProductForm) return;
  
  // TODO: We maybe should make this to update all the inputs (side-cart support?)
  const input = sofiaMainProductForm.querySelector('input[name="id"]');
  input.value = variantId ?? "";
}

function sofiaUpdatePrice(sofiaMainProductPrice) {
  const previousSofiaMainProductPrice = document.querySelector(".sofia-main-product-price");
  if (!previousSofiaMainProductPrice) return;

  previousSofiaMainProductPrice.innerHTML = sofiaMainProductPrice.innerHTML;
}

function sofiaHandleUpdateProductInfo(productUrl) {
  return (html) => {
    const sofiaMainProduct = html.querySelector(".sofia-main-product");
    if (!sofiaMainProduct) return;

    const variant = sofiaGetSelectedVariant(sofiaMainProduct);

    sofiaUpdateURL(productUrl, variant?.id);
    sofiaUpdateVariantInputs(variant?.id);

    const sofiaMainProductPrice = sofiaMainProduct.querySelector(".sofia-main-product-price");
    if (sofiaMainProductPrice) sofiaUpdatePrice(sofiaMainProductPrice);

    if (!variant) return;

    sofiaUpdateMedia(variant?.featured_media?.id);
  };
}

function sofiaUpdateURL(url, variantId) {
  window.history.replaceState(
    {},
    "",
    `${url}${variantId ? `?variant=${variantId}` : ""}`
  );
}

function sofiaUpdateMedia(mediaId) {
  if (!mediaId) return;

  const sofiaMainProduct = document.querySelector(".sofia-main-product");
  const sofiaMainProductGallery = sofiaMainProduct?.querySelector(".sofia-main-product-gallery");
  if (!sofiaMainProductGallery) return;

  const activeMedia =
    sofiaMainProductGallery.querySelector('[data-sofia-media-id="' + mediaId +'"]');
  if (!activeMedia) return;
  
  sofiaMainProductGallery
    .querySelectorAll("[data-sofia-media-id]")
    .forEach((media) => {
      media.classList.remove("sofia-active");
    });
  activeMedia?.classList.add("sofia-active");
  
  window.setTimeout(() => {
    activeMedia.scrollIntoView({ behavior: "instant", inline: "center", block: "nearest" });
  
    const activeMediaRect = activeMedia.getBoundingClientRect();
    // Do not scroll page if active media is already in view
    if (activeMediaRect.top > -0.5) return;
    const top = activeMediaRect.top + window.scrollY;
    window.scrollTo({ top: top, behavior: "smooth" });
  });
}

async function sofiaAddItemsToCart(items, redirect = true) {
  let result = null;
  
  // If the theme has a custom add to cart functionality, use it instead of the default functionality
  const shopifyThemeSchemaName = window.Shopify?.theme?.schema_name?.toLowerCase();
  if (shopifyThemeSchemaName && sofiaDefaultFunctionalityOverrides[shopifyThemeSchemaName]) {
    try {
      result = await sofiaDefaultFunctionalityOverrides[shopifyThemeSchemaName].addToCart(items);
    } catch (error) {
      console.error(error);
    }
  } else {
    const config = sofiaFetchConfig();
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.body = JSON.stringify({
      items: items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
      })),
    });
    const response = await fetch(window.sofiaRoutes.cart_add_url, config);
    result = await response.json();
  }

  if (result?.errors) {
    throw new Error(
      Array.isArray(result.errors)
        ? result.errors.join(", ")
        : result.errors
    );
  }
  
  // Enable the Add to Cart button in case the user navigates back to the product page
  const submitButton = document.querySelector('.sofia-main-product-button__submit');
  if (submitButton) submitButton.removeAttribute('aria-disabled');

  if (redirect) window.location = window.sofiaRoutes.cart_url;
}

// Theme-specific functionality overrides
const sofiaDefaultFunctionalityOverrides = {
  denim: {
    addToCart:
      async function (items) {
        const themeCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const config = fetchConfig();
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = {
          items: items.map((item) => ({
            id: item.id,
            quantity: item.quantity,
          })),
        };

        if (themeCart) {
          config.body.sections = themeCart.getSectionsToRender().map((section) => section.id);
          config.body.sections_url = window.location.pathname;
          themeCart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(config.body);

        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (!themeCart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: items[0]?.id,
              cartData: response,
            });

            const quickAddModal = document.querySelector('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => themeCart.renderContents(response));
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else themeCart.renderContents(response);

            return response;
          })
          .catch(console.error)
          .finally(() => {
            if (themeCart && themeCart.classList.contains('is-empty')) themeCart.classList.remove('is-empty');
          });
      }
  }
}
